<template>
  <div class="base-echart" :style="{ height: height }">
    <v-chart
      ref="chart"
      :option="option"
      :loading="loading"
      :loading-options="loadingConfig"
      :autoresize="true"
      :init-options="initOptions"
      class="base-echart__canvas"
    />
  </div>
</template>

<script>
import VChart from 'vue-echarts'
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import {
  BarChart,
  PieChart,
  LineChart,
  GaugeChart,
} from 'echarts/charts'
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  MarkLineComponent,
  MarkPointComponent,
  DataZoomComponent,
} from 'echarts/components'
import { loadingConfig } from './echartsTheme'

// Register only the modules we use (tree-shaking).
use([
  CanvasRenderer,
  BarChart,
  PieChart,
  LineChart,
  GaugeChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  MarkLineComponent,
  MarkPointComponent,
  DataZoomComponent,
])

export default {
  name: 'BaseEChart',

  components: { VChart },

  props: {
    option: { type: Object, required: true },
    loading: { type: Boolean, default: false },
    height: { type: String, default: '320px' },
  },

  data() {
    return {
      loadingConfig,
      initOptions: { renderer: 'canvas' },
    }
  },
}
</script>

<style scoped>
.base-echart {
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  background: linear-gradient(180deg, #ffffff 0%, #fbfcfd 100%);
  border: 1px solid #f0f3f5;
  padding: 8px;
  box-sizing: border-box;
}

.base-echart__canvas {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  overflow: hidden;
}

/* Make ECharts inner canvas honor rounded corners */
.base-echart :deep(canvas) {
  border-radius: 8px !important;
}
</style>
